<template>
<div class="chapter">
<div class="inner_page">
<p class="ch">Table of Contents</p>
<p class="toc"><a href="#/OEBPS/c01.htm">CHAPTER ONE</a></p>
<p class="toc"><a href="#/OEBPS/c02.htm">CHAPTER TWO</a></p>
<p class="toc"><a href="#/OEBPS/c03.htm">CHAPTER THREE</a></p>
<p class="toc"><a href="#/OEBPS/c04.htm">CHAPTER FOUR</a></p>
<p class="toc"><a href="#/OEBPS/c05.htm">CHAPTER FIVE</a></p>
<p class="toc"><a href="#/OEBPS/c06.htm">CHAPTER SIX</a></p>
<p class="toc"><a href="#/OEBPS/c07.htm">CHAPTER SEVEN</a></p>
<p class="toc"><a href="#/OEBPS/c08.htm">CHAPTER EIGHT</a></p>
<p class="toc"><a href="#/OEBPS/c09.htm">CHAPTER NINE</a></p>
<p class="toc"><a href="#/OEBPS/c10.htm">CHAPTER TEN</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?001e8f24